import { UserHelper } from '@/helpers/user.helper';
import { Paging } from '@/models/Paging';
import { AlertService } from '@/services/alert.service';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { ConnectorCode, ConnectorUserPaginatedList, ConnectorsService } from '@eemo/api-client';
import { Subscription, catchError, map, merge, of as observableOf, startWith, switchMap } from 'rxjs';
import { DateTimeFormatPipe } from '@/extensions/dateTimePipe';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
    selector: 'app-admin-connectors-config',
    templateUrl: './admin-connectors-config.component.html',
    styleUrls: ['./admin-connectors-config.component.scss'],
    standalone: true,
    imports: [MatExpansionModule, MatFormFieldModule, MatInputModule, FormsModule, MatSelectModule, MatOptionModule, MatDividerModule, NgIf, MatProgressSpinnerModule, MatTableModule, MatSortModule, MatPaginatorModule, DateTimeFormatPipe]
})
export class AdminConnectorsConfigComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  UserHelper = UserHelper;

  dataList: ConnectorUserPaginatedList;
  data: any[];
  displayedColumns = ['code', 'user', 'configurationDate'];
  resultsLength = 0;
  isLoadingResults = true;

  filterConnector: ConnectorCode;
  filterName: string;

  sub = new Subscription();
  sortSub = new Subscription();

  paging = new Paging();

  constructor(private connectorService: ConnectorsService, private alerteService: AlertService) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.sortSub.unsubscribe();
  }

  ngAfterViewInit() {
    // If the user changes the sort order, reset back to the first page.
    this.sortSub = this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    this.loadData();
  }

  loadData() {
    const filterNameValue = this.filterName && this.filterName.length > 2 ? this.filterName : null;
    this.sub = merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.connectorService.getConnectorsConfigured(
            this.filterConnector,
            null,
            filterNameValue,
            this.paginator.pageIndex * this.paginator.pageSize,
            this.paginator.pageSize
          );
        }),
        map((dataList) => {
          this.dataList = dataList;
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.resultsLength = dataList.paging.totalItems;
          this.alerteService.clear();
          const displayedData = [];
          dataList.list.forEach((i) => {
            const row = {
              config: i,
              user: UserHelper.userSummmaryDisplayName(i.user)
            };
            displayedData.push(row);
          });
          return displayedData;
        }),
        catchError((error) => {
          this.isLoadingResults = false;
          return observableOf([]);
        })
      )
      .subscribe((data) => (this.data = data));
  }

  updateDataFromFilters() {
    this.paginator.pageIndex = 0;
    this.loadData();
  }
}
